import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';

// @ts-ignore bypass forbidden
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
